import chat from './chat'
import { combineReducers } from 'redux'

const chatReducer = combineReducers({
  chat
})

export default chatReducer
